import {
  ZAD_LIBRARY_ROLE_INDEX,
  getRolePathPrefixes,
  normalizeRoutePath,
  resolveRoleIndex,
} from './roles'

export type MaarefatiWorkspace = 'zad' | 'maarefati'

export function isZadRoute(pathname: string): boolean {
  const path = normalizeRoutePath(pathname)
  return path === '/zad' || path.startsWith('/zad/')
}

export function isZadLibraryRole(role: string | number | undefined | null): boolean {
  return resolveRoleIndex(role) === ZAD_LIBRARY_ROLE_INDEX
}

export function hasZadOperationalMenu(role: string | number | undefined | null): boolean {
  return Boolean(getRolePathPrefixes(role)?.includes('/zad'))
}

export function resolveWorkspace(
  role: string | number | undefined | null,
  pathname: string
): MaarefatiWorkspace {
  if (!hasZadOperationalMenu(role)) return 'maarefati'
  if (isZadLibraryRole(role)) return 'zad'
  return isZadRoute(pathname) ? 'zad' : 'maarefati'
}

export function shouldShowZadSidebar(
  role: string | number | undefined | null,
  pathname: string
): boolean {
  return resolveWorkspace(role, pathname) === 'zad'
}

export function shouldShowMaarefatiSidebar(
  role: string | number | undefined | null,
  pathname: string
): boolean {
  return resolveWorkspace(role, pathname) === 'maarefati'
}

export function shouldShowZadLauncher(
  role: string | number | undefined | null,
  pathname: string
): boolean {
  return hasZadOperationalMenu(role) && !isZadLibraryRole(role) && !isZadRoute(pathname)
}

export function shouldShowBackToMaarefati(
  role: string | number | undefined | null,
  pathname: string
): boolean {
  return shouldShowZadSidebar(role, pathname) && !isZadLibraryRole(role)
}

export function getMaarefatiLandingPath(role: string | number | undefined | null): string {
  const prefixes = getRolePathPrefixes(role) || []
  return prefixes.find((path) => path !== '/zad' && !path.startsWith('/zad/')) || '/info-center'
}
